import Essence1 from '../../Media/Residential/essence.webp'
import Essence2 from '../..//Media/Residential/essence.webp'


const Essenceimages =[
Essence1,Essence2
]

export default Essenceimages;